import { jsx as p } from "react/jsx-runtime";
import { Form as e } from "antd";
import { u as i } from "./styled-components.browser.esm-3eb04950.js";
const I = ({ children: m, name: o, rules: t, initialValue: r }) => /* @__PURE__ */ p(
  s,
  {
    name: o,
    rules: t,
    initialValue: r,
    children: m
  }
), s = i(e.Item)`
  margin-bottom: 0;
  width: 100%;
`;
export {
  I as WrapperItem
};
//# sourceMappingURL=WrapperItem.js.map
